import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useSearchParams } from 'react-router-dom';

import { ChakraProvider, LightMode } from '@chakra-ui/react';

import { useAccessList } from '@tcap/data-router/hooks/useAccessList';

import { LoadingScreen } from '@/lib/loading-screen';

import chakratheme from '@/chakratheme';
// login page
export default function AuthRouteLayout() {
    const { loadAccessList, token, loggedIn, reLogin, showMFA } = useSelector(
        (state) => state.login,
    );
    const { getAccessList } = useAccessList();
    const [searchParams] = useSearchParams();
    let redirectTo =
        new URLSearchParams(searchParams).get('redirectTo') ||
        import.meta.env.VITE_APP_DEFAULT_REDIRECT_URL;
    /**
     * After logging in, this flag kicks off the data fetching process
     * required for TCAP.
     */
    useEffect(() => {
        //load access list after a succesful login/ relogin.
        if (loadAccessList) {
            getAccessList();
        }
    }, [loadAccessList, getAccessList]);

    if (loadAccessList) {
        return (
            <ChakraProvider theme={chakratheme} resetCSS={true}>
                <LoadingScreen />
            </ChakraProvider>
        );
    }

    if (!token || !loggedIn || reLogin || showMFA) {
        window.sessionStorage.clear();
        return (
            <ChakraProvider theme={chakratheme} resetCSS={true}>
                <LightMode>
                    <div
                        style={{
                            backgroundColor: 'white',
                            color: '#1A202C',
                            minHeight: '100vh',
                            '--chakra-colors-chakra-body-bg': 'white',
                            '--chakra-colors-chakra-body-text': '#1A202C',
                        }}>
                        <Outlet context={{ token, loadAccessList }} />
                    </div>
                </LightMode>
            </ChakraProvider>
        );
    }

    return <Navigate to={redirectTo} replace />;
}
